import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import { Order } from 'PMT/entities/order';
import { OrderViewUtils } from 'PMT/utils';

import Step from './Step';

export default class OrderStatusStepper extends Component {

  static propTypes = {
    status: PropTypes.string.isRequired,

    nextStatus: PropTypes.string.isRequired,

    onNextStatus: PropTypes.func.isRequired,

    orderMode: PropTypes.number.isRequired,

    /**
    * @param newStatus
    */
    onChange: PropTypes.func
  };

  get steps() {
    const status = this.props.orderMode === Order.OrderMode.DELIVERY ? Order.getStepsWithDelivery(): Order.getStepsWithoutDelivery();

    const steps = [];

    _.each(status, (status) => {
      steps.push({
        label: OrderViewUtils.getStatusLabel(status),
        value: status,
      });
    });

    return steps;
  };

  getStyles = () => {
    return {
      root: {
        width: '100%',
        minHeight: 0,
        padding: 0,
      },
      stepper: {
        display: 'table',
        width: '100%',
        margin: '0 auto',
      },
    };
  };

  renderStep(stepInfo, index) {
    const {
      activeStep, activeColor, completeColor, defaultColor, circleFontColor,
      activeTitleColor, completeTitleColor, defaultTitleColor,
      size, circleFontSize, titleFontSize,
      circleTop, titleTop,
    } = this.props;

    return React.createElement(Step, {
      key: index,
      width: 100 / this.steps.length,
      label: stepInfo.label,
      status: stepInfo.value,
      active: this.props.status === stepInfo.value,
      completed: Order.isStatusBefore(stepInfo.value, this.props.status),
      first: index === 0,
      last: index === this.steps.length - 1,
      index,
      isNext: this.props.nextStatus === stepInfo.value,
      onNextStatus: this.props.onNextStatus
    });
  }

  render() {
    const styles = this.getStyles();

    return (
      <div style={styles.root}>
        <div style={styles.stepper}>
          { this.steps.map((stepInfo, index) => this.renderStep(stepInfo, index)) }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/order/orderStatusStepper/OrderStatusStepper.js